import{useRef as r,useState as e,useCallback as n}from'react';function t(){const t=r(null),[o,c]=e({});return{handleRef:n(r=>{t.current=r,c([])},[]),ref:t}}export{t as useCallbackRef};
